<template>
<div class="nkn-why">
  <div class="common-title">{{$t("home.whynkn.title")}}</div>
  <div class="nkn-content">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 why-content">
        <why-module>
          <img v-lazy="'/static/img/home/whynkn/client-server.png'" class="why-pic pic-nknwhy-client-server" slot="why-pic">
          <span slot="why-title">{{$t("home.whynkn.subtitle1")}}</span>
          <span slot="why-content">{{$t("home.whynkn.subContent1")}} </span>
        </why-module>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 why-content">
        <why-module>
          <img v-lazy="'/static/img/home/whynkn/waste.png'" class="why-pic pic-nknwhy-waste" slot="why-pic">
          <span slot="why-title">{{$t("home.whynkn.subtitle2")}}</span>
          <span slot="why-content">{{$t("home.whynkn.subContent2")}}</span>
        </why-module>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 why-content">
        <why-module>
          <img v-lazy="'/static/img/home/whynkn/center.png'" class="why-pic pic-nknwhy-center" slot="why-pic">
          <span slot="why-title">{{$t("home.whynkn.subtitle3")}}</span>
          <span slot="why-content">{{$t("home.whynkn.subContent3")}}</span>
        </why-module>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import WhyModule from '@/components/home/plugins/WhyModule.vue'
export default {
  components: {
    WhyModule
  }
}
</script>

<style lang="scss" scoped>
.nkn-why {
  @include common-inner();
  @media screen and (max-width: 768px) {
    .why-content {
      margin-bottom: 60px;
    }
  }

  .nkn-content{
    margin-top: 2rem;
  }

  .why-pic {
    width: 110px;
    height: auto;
  }

  &-content {
    margin-top: 80px;

    @media screen and (max-width: 768px) {
      margin-left: 3rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/nknWhy.vue